import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthGuard } from './auth.guard';
import { AuthenticationService } from '../services/auth.service';
import { FirestoreService } from '../services/firestore.service';
// import firebase from 'firebase/app';
// import 'firebase/firestore';
import { map, tap } from 'rxjs/operators';
import { HostService } from '../services/host.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements /*CanActivate,*/ CanLoad {

  constructor(private authService: AuthenticationService, private router: Router, private hostService: HostService) {}

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const cu = this.authService.currentUser();
    return this.authService.getUserRole(this.hostService.selectedHost$.value?.id).pipe(
      map(role => {
        console.log(route.path, role);
        switch (route.path) {
          case 'dashboard':
          case 'processes':
            // ezek már betöltődhetnek user role-al is
            if (!role) {
              this.router.navigate(['']);
              return false;
            } else {
              return true;
            }
          case 'maintenance':
            if (role === 'hostAdmin' || role === 'sysAdmin') {
              return true;
            } else {
              this.router.navigate(['']);
              return false;
            }
          case 'system':
            if (role === 'sysAdmin') {
              return true;
            } else {
              this.router.navigate(['']);
              return false;
            }
          default:
            return false;
        }
      })
    )
  }

  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

  //     if (this.authGuard.canActivate(route, state)) {
  //       return true;

  //       /* ide majd az admin ellenőrzés */
  //     } else {
  //       return false;
  //     }

  // }

}
